import { render, staticRenderFns } from "./userBox.vue?vue&type=template&id=18bc9fbb&"
import script from "./userBox.vue?vue&type=script&lang=js&"
export * from "./userBox.vue?vue&type=script&lang=js&"
import style0 from "./userBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports